/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import GridView from '@/views/GridView';
import StringCell from '@/backgrid/StringCell';
import { DateCell } from '@/backgrid/MomentCell';
import ButtonLinkCell from '@/backgrid/ButtonLinkCell';
import LinkCell from '@/backgrid/LinkCell';
import PageableCollection from '@/backbone/PageableCollection';

const AssessmentDashboardGridView = GridView.extend({
  initialize() {
    const isInternalUser = !EXTERNAL;

    (this.options.columns = [
      {
        name: 'id',
        label: 'Assessment ID',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortable: true
      },
      {
        name: 'crsOwnerName',
        label: 'Assigned CRS',
        cell: StringCell,
        headerCell: 'custom',
        width: EXTERNAL ? 12 : 10,
        editable: false,
        sortable: true
      },
      {
        name: 'customerName',
        label: 'Customer',
        cell: StringCell,
        headerCell: 'custom',
        width: EXTERNAL ? 12 : 10,
        editable: false,
        sortable: true
      },
      {
        name: 'commandName',
        label: 'Command',
        cell: LinkCell.extend({
          name() {
            return this.model.get('commandName');
          },
          href(model) {
            return `#command/${model.get('commandId')}`;
          },
          newTab: true
        }),
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortable: true,
        renderable: !EXTERNAL
      },
      {
        name: 'type',
        label: 'Assessment Type',
        cell: StringCell,
        headerCell: 'custom',
        width: 12,
        editable: false,
        sortable: true
      },
      {
        name: isInternalUser ? 'internalAssessmentStatus' : 'externalAssessmentStatus',
        label: 'Assessment Status',
        cell: StringCell,
        headerCell: 'custom',
        width: 12,
        editable: false,
        sortable: true
      },
      {
        name: 'serviceBranchName',
        label: 'Branch',
        cell: StringCell,
        headerCell: 'custom',
        width: EXTERNAL ? 12 : 10,
        editable: false,
        sortable: true
      },
      {
        name: 'regionCode',
        label: 'Region',
        cell: StringCell,
        headerCell: 'custom',
        width: EXTERNAL ? 10 : 8,
        editable: false,
        sortable: true
      },
      {
        name: 'submittedOn',
        label: 'Submitted On',
        cell: DateCell,
        headerCell: 'custom',
        width: EXTERNAL ? 12 : 10,
        editable: false,
        sortable: true
      },
      {
        name: '',
        label: '',
        editable: false,
        sortable: false,
        cell: ButtonLinkCell.extend({
          name: 'Open',
          href(model) {
            return `#assessment/${model.get('id')}`;
          },
          buttonClass(model) {
            return isInternalUser && model.get('internalAssessmentStatus') === 'CRS Pending Assignment'
              ? 'd-none'
              : 'btn-sm btn-outline-primary';
          },
          newTab: true
        })
      }
    ]),
      (this.collection = new PageableCollection([], { pageSize: 50 }));
    this.options.emptyText = 'No Assessments Found';
    GridView.prototype.initialize?.apply(this, this.options);
  }
});

export default AssessmentDashboardGridView;
